import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Controller } from "react-hook-form";
import SellerDetailReadOnly from "./SellerDetailReadOnly";
import { getddmmyyyyFormat } from "../../Helpers/Helper";
import BuyerFormSellerContacts from "./BuyerFormSellerContacts";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import SubmitLoader from "../SubmitLoader";
import { useNavigate, useLocation, Link } from "react-router-dom";

const SellerPopulated = ({
  register,
  watch,
  control,
  errors,
  getFieldState,
  sellerInfo,
  clearErrors,
  isCompanyFieldName,
  setError,
  uploadSizeLimit,
  setValue,
  resQueryPcCraft,
  isLoadingQueryPcCraft,
  errGetQueryPcCraft,
  setCurrentPcRego,
  isDisplayPersonaIdLabel,
  setIsDisplayPersonaIdLabel,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBoatRegiEvt = () => {
    navigate("/boatregistration", {
      state: { from: location },
      replace: false,
    });
  };

  useEffect(() => {
    if (
      sellerInfo == null &&
      !resQueryPcCraft &&
      !isLoadingQueryPcCraft &&
      watch("sellerRegoNo") !== ""
    ) {
      setError("sellerRegoNo", {
        type: "required",
        message: errGetQueryPcCraft
          ? errGetQueryPcCraft
          : "We could not find a match for the registration number entered. Please try it again or contact MAST, Monday to Friday, 8.30 am to 5.00 pm on 6235 8888",
      });
      setIsDisplayPersonaIdLabel(true);
    }

    if (
      sellerInfo == null &&
      resQueryPcCraft != null &&
      !isLoadingQueryPcCraft &&
      resQueryPcCraft?.is_duplicated_transfer_vessel === true
    ) {
      setError("sellerRegoNo", {
        type: "duplicatedTransferVessel",
        message: "duplicatedTransferVessel",
      });
      setIsDisplayPersonaIdLabel(true);
    } else if (
      sellerInfo == null &&
      resQueryPcCraft != null &&
      !isLoadingQueryPcCraft &&
      resQueryPcCraft?.is_valid_vessel === false
    ) {
      setError("sellerRegoNo", {
        type: "notValidBoat",
        message: "notValidBoat",
      });
      setIsDisplayPersonaIdLabel(true);
    }

    if (
      sellerInfo == null &&
      resQueryPcCraft &&
      watch("sellerRegoNo") !== resQueryPcCraft.pc_rego_no &&
      !isLoadingQueryPcCraft
    ) {
      setValue("sellerRegoNo", resQueryPcCraft.pc_rego_no, {
        shouldValidate: true, // optional: re-trigger validation
        shouldDirty: true, // optional: mark as dirty
        shouldTouch: true, // optional: mark as touched
      });
      setCurrentPcRego(resQueryPcCraft.pc_rego_no);
      setIsDisplayPersonaIdLabel(false);
    }

    if (
      sellerInfo == null &&
      resQueryPcCraft != null &&
      !isLoadingQueryPcCraft
    ) {
      setValue("sellerBoatName", resQueryPcCraft.pc_name, {
        shouldValidate: true, // optional: re-trigger validation
        shouldDirty: true, // optional: mark as dirty
        shouldTouch: true, // optional: mark as touched
      });
      setValue("pcLength", resQueryPcCraft.pc_length, {
        shouldValidate: true, // optional: re-trigger validation
        shouldDirty: true, // optional: mark as dirty
        shouldTouch: true, // optional: mark as touched
      });
    }
  }, [isLoadingQueryPcCraft]);

  useEffect(() => {
    if (sellerInfo != null && sellerInfo.length > 0) {
      setValue("sellerRegoNo", sellerInfo[0]?.pcRegoNo, {
        shouldValidate: true, // optional: re-trigger validation
        shouldDirty: true, // optional: mark as dirty
        shouldTouch: true, // optional: mark as touched
      });
    }
  }, [sellerInfo]);

  return (
    <>
      {sellerInfo != null && sellerInfo.length > 0 ? (
        <>
          {isLoadingQueryPcCraft ? (
            <SubmitLoader isLoading={isLoadingQueryPcCraft} />
          ) : (
            <>
              <div className="br-box">
                <div className="br-title">Purchase of Vessel</div>
                <div className="br-field-group">
                  <div className="br-input-group">
                    <label htmlFor="dateOfPurchase">Date of Purchase</label>
                    <div className="br-field-readonly unSelectable">
                      {getddmmyyyyFormat(
                        sellerInfo[0]?.dateOfPurchase?.split("T")[0],
                      )}
                    </div>
                  </div>
                  <div className="br-input-group">
                    <label htmlFor="sellerRegoNo">Rego No.</label>
                    <div className="br-field-readonly unSelectable">
                      {sellerInfo[0]?.pcRegoNo}
                    </div>
                  </div>
                  <div className="br-input-group">
                    <label htmlFor="sellerBoatName">Boat Name</label>
                    <div className="br-field-readonly unSelectable">
                      {sellerInfo[0]?.pcName}
                    </div>
                  </div>
                </div>
              </div>
              <SellerDetailReadOnly
                PrimaryTitle="Registered Operator (Seller)"
                client={sellerInfo[0]}
              />
            </>
          )}
        </>
      ) : (
        <>
          <div className="br-box">
            <div className="br-title">Purchase of Vessel</div>
            <div className="br-field-group">
              <div
                className={
                  errors.dateOfPurchase?.message
                    ? "br-input-group error"
                    : !getFieldState("dateOfPurchase").isDirty
                      ? "br-input-group"
                      : "br-input-group success"
                }
              >
                <label htmlFor="dateOfPurchase">
                  Date of Purchase<span className="text-danger">*</span>
                </label>
                <Controller
                  control={control}
                  name="dateOfPurchase"
                  render={({ field: { onChange, value } }) => {
                    return (
                      <DatePicker
                        value={value}
                        onChange={onChange}
                        defaultValue={dayjs()}
                        disableFuture
                        views={["year", "month", "day"]}
                      />
                    );
                  }}
                  rules={{
                    required: "Purchase Date is required",
                    validate: {
                      min: (v) =>
                        new Date(v) >= new Date(1900, 0, 1) ||
                        "Selected year must be greater than 1900",
                      max: (v) =>
                        new Date(v) <= new Date() ||
                        "Selected date must be less than today",
                    },
                  }}
                  errors={errors}
                />
                <span className="msg">{errors.dateOfPurchase?.message}</span>
              </div>
              <div
                className={
                  errors.sellerRegoNo?.message
                    ? "br-input-group error"
                    : !getFieldState("sellerRegoNo").isDirty
                      ? "br-input-group"
                      : "br-input-group success"
                }
              >
                <label htmlFor="sellerRegoNo" className="space-between-group">
                  <div>
                    Vessel Rego No.
                    {isDisplayPersonaIdLabel && " / Personalised ID"}
                    <span className="text-danger">*</span>
                  </div>
                  {resQueryPcCraft &&
                    resQueryPcCraft?.is_valid_vessel === true && (
                      <FontAwesomeIcon icon={faCheck} className="valid" />
                    )}
                </label>
                <input
                  type="text"
                  id="sellerRegoNo"
                  {...register("sellerRegoNo", {
                    required: "Rego/Personal ID is required",
                    validate: {
                      validVessel: () => {
                        if (
                          resQueryPcCraft &&
                          resQueryPcCraft.is_duplicated_transfer_vessel ===
                            true &&
                          watch("sellerRegoNo") === resQueryPcCraft.pc_rego_no
                        ) {
                          return "duplicatedTransferVessel";
                        }
                        // Only validate if we have query results and vessel is invalid
                        else if (
                          resQueryPcCraft &&
                          resQueryPcCraft.is_valid_vessel === false &&
                          watch("sellerRegoNo") === resQueryPcCraft.pc_rego_no
                        ) {
                          return "notValidBoat";
                        }
                        return true;
                      },
                    },
                  })}
                />
                <span className="msg">
                  {errors.sellerRegoNo?.message === "notValidBoat" ? (
                    <span>
                      This vessel cannot be transferred. You must register it as
                      a new vessel{" "}
                      <Link to="/boatregistration" onClick={handleBoatRegiEvt}>
                        here
                      </Link>{" "}
                      or contact MAST, Monday to Friday, 8.30 am to 5.00 pm on
                      6235 8888
                    </span>
                  ) : errors.sellerRegoNo?.message ===
                    "duplicatedTransferVessel" ? (
                    <span>
                      You cannot continue with this transfer process because
                      this vessel is already in the process of being
                      transferred. Please contact MAST, Monday to Friday, 8.30
                      am to 5.00 pm on 6235 8888 if this is not expected.
                    </span>
                  ) : (
                    <span>{errors.sellerRegoNo?.message}</span>
                  )}
                </span>
              </div>
              {isLoadingQueryPcCraft ? (
                <SubmitLoader isLoading={isLoadingQueryPcCraft} />
              ) : (
                resQueryPcCraft &&
                resQueryPcCraft?.is_valid_vessel === true && (
                  <>
                    <div className="br-input-group">
                      <label htmlFor="sellerBoatName">Boat Name</label>
                      <div className="br-field-readonly unSelectable">
                        {resQueryPcCraft?.pc_name}
                      </div>
                    </div>
                    <div className="br-input-group">
                      <label htmlFor="pcLength">Boat Length(m)</label>
                      <div className="br-field-readonly unSelectable">
                        {resQueryPcCraft?.pc_length}
                      </div>
                    </div>
                    <div className="br-input-group">
                      <label htmlFor="pcClass">Classification</label>
                      <div className="br-field-readonly unSelectable">
                        {resQueryPcCraft?.pc_class_code}
                      </div>
                    </div>
                    <div className="br-input-group">
                      <label htmlFor="pcMake">Make</label>
                      <div className="br-field-readonly unSelectable">
                        {resQueryPcCraft?.pc_hull_make}
                      </div>
                    </div>
                    <div className="br-input-group">
                      <label htmlFor="pcModel">Model</label>
                      <div className="br-field-readonly unSelectable">
                        {resQueryPcCraft?.pc_hull_model}
                      </div>
                    </div>
                    {resQueryPcCraft?.pc_personalised_id && (
                      <div className="br-input-group">
                        <label htmlFor="pcPersonalId">Personalised ID</label>
                        <div className="br-field-readonly unSelectable">
                          {resQueryPcCraft?.pc_personalised_id}
                        </div>
                      </div>
                    )}
                  </>
                )
              )}
            </div>
          </div>
          {resQueryPcCraft && resQueryPcCraft?.is_valid_vessel === true && (
            <BuyerFormSellerContacts
              register={register}
              watch={watch}
              control={control}
              errors={errors}
              getFieldState={getFieldState}
              clearErrors={clearErrors}
              isCompanyFieldName={isCompanyFieldName}
              setError={setError}
              uploadSizeLimit={uploadSizeLimit}
              setValue={setValue}
            />
          )}
        </>
      )}
    </>
  );
};

export default SellerPopulated;
